// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rx-6";
export var imgContainer = "_rx-3";
export var menuIcon = "_rx-5";
export var pillWrapper = "_rx-2";
export var pillsContainer = "_rx-1";
export var subscriptionCard = "_rx-0";
export var subscriptionLogo = "_rx-4";